
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"20","height":"20","rx":"10","fill":"#D7F2E3"}}),_c('path',{attrs:{"d":"M11 5H9V7H11V5Z","fill":"#00A769"}}),_c('path',{attrs:{"d":"M8 9H11V15H9V10H8V9Z","fill":"#00A769"}})])
          )
        }
      }
    